<template>
  <div>
    <multiselect
      v-model="selected"
      @input="onChange"
      :options="options"
      :custom-label="labelTipoResultado"
      :multiple="isMulti"
      :taggable="isTagabble"
      selectLabel=""
      selectedLabel="«"
      deselectLabel=""
      :allowEmpty="false"
      :preselectFirst="preselectFirst"
      :loading="isLoading"
      label="nome"
      track-by="id"
      :disabled="isDisabled || isLoading || !this.tipoSub"
      placeholder=""
    >
      <template slot="noResult" slot-scope="props">
        <span>{{ $t('Nenhum elemento encontrado.') }}</span>
      </template>
      <template slot="noOptions" slot-scope="props">
        <span>{{ $t('Nenhum dado foi retornado.') }}</span>
      </template>
      <template slot="placeholder" slot-scope="props">
        <span>{{ $t(emptyLabel) }}</span>
      </template>
      <template slot="tag" slot-scope="{ option }"
        ><span class="badge badge-primary mr-1"
          ><span class="text-truncate mr-1 mb-1">{{ option.nome }}</span
          ><span class="custom__remove badge" @mousedown.prevent.stop="removeOption(option)">x</span></span
        ></template
      >
      <template slot="clear" slot-scope="props">
        <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble',
    'alreadyAdded',
    'tipoSub',
    'preselectFirst'
  ],

  data() {
    return {
      selected: [],
      value: [],
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e?.id === 0 || e === 0) {
        this.$emit('selectChange', 'tipo_resultado', e);
        return;
      }
      if (e === null || e === undefined) {
        this.$emit('selectChange', 'tipo_resultado', null);
        return;
      }
      this.$emit('selectChange', 'tipo_resultado', e);
      this.$emit('input', e);
    },
    labelTipoResultado({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (this.isTagabble) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'tipo_resultado', value);
      } else {
        if (value) {
          if (value.id) {
            this.selected = this.options.find((option) => option.id === value.id);
          } else {
            this.selected = this.options.find((option) => option.id === value);
          }
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
        this.$emit('input', this.selected);
      }
    },
    preselectFirstCheck() {
      // if (this.options?.length === 1 && !this.selected && this.preselectFirst === true) {
      //   this.selected = this.$util.getObjectRaw(this.options[0]);
      //   this.setValue(this.$util.getObjectRaw(this.selected));
      // }
    },
    clearAll() {
      this.value = [];
    },
    setOptions() {
      this.options = [];
      if (!this.tipoSub) return;
      this.isLoading = true;
      this.$atenaList
        .getCommon(`subevento/opcoes?tipoSub=${this.tipoSub}`)
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res?.opcoes || []);
          this.options = this.options.map((option) => ({
            id: `${option.tipoResultado}`,
            ...option,
            ...res
          }));

          // remover ids duplicados
          this.options = this.options.filter(
            (option, index, self) => index === self.findIndex((t) => t.id === option.id)
          );

          this.options = this.options.map((option) => ({
            ...option,
            nome: this.nomesTiposResultado[option.id] || option.nome
          }));

          if (this.alreadyAdded) {
            this.removeOptions(this.alreadyAdded);
          }
          this.setValue(this.nameField);
          this.isLoading = false;

          this.preselectFirstCheck();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    removeOptions(options) {
      if (!options) return;
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.id === element.id);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.id === option.id);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.id != el.id);
        }
      });

      this.setValue(valueCp);
      this.options = [option, ...this.options];
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    },
    tipoSub: function (value) {
      this.setOptions();
    }
  },
  computed: {
    nomesTiposResultado() {
      return {
        0: 'Indistinto (não há identificação)',
        1: 'Casa',
        2: 'Empate',
        3: 'Fora',
        9: 'Sim',
        10: 'Não'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__remove {
  background: #26b4ff !important;
  color: #fff;
  transition: ease 0.2s all;
}

.custom__remove:hover {
  cursor: pointer;
  background: #0097e9 !important;
}
</style>
